export default class Shelf extends Phaser.Group {
  constructor({ game, gx, size, row, shelfType }) {
    super(game);
    this.row = row;
    if (size == 1) {
      this.costume = this.game.make.image(0, 0, 'shelves', 'shelf_1');
      this.row.cells[gx] = 1;
    } else {
      this.costume = this.game.make.image(0, 0, 'shelves', shelfType);
      if (gx >= 0 && gx < this.row.cellsInRow) {
        this.row.cells[gx] = 1;
      }
      if (gx > 0) {
        this.row.cells[gx - 1] = 1;
      }
      if (gx < this.row.cellsInRow - 1) {
        this.row.cells[gx + 1] = 1;
      }
    }
    this.costume.anchor.set(0.5, 1);
    this.costume.y = 44;
    this.addChild(this.costume);

    // customise content
    /*if (size == 3) {
      let type = this.game.rnd.integerInRange(1, 2);
      let boxesSmall = this.game.make.image(0, -136, 'shelves', 'boxes_small_' + type);
      boxesSmall.anchor.set(0.5, 1);
      this.costume.addChild(boxesSmall);

      type = this.game.rnd.integerInRange(1, 2);
      let bottles = this.game.make.image(0, -91, 'shelves', 'bottles_' + type);
      bottles.anchor.set(0.5, 1);
      this.costume.addChild(bottles);

      type = this.game.rnd.integerInRange(1, 2);
      let boxesBig = this.game.make.image(0, -53, 'shelves', 'boxes_big_' + type);
      boxesBig.anchor.set(0.5, 1);
      this.costume.addChild(boxesBig);

      type = this.game.rnd.integerInRange(1, 2);
      let shirts = this.game.make.image(0, -20, 'shelves', 'shirts_' + type);
      shirts.anchor.set(0.5, 1);
      this.costume.addChild(shirts);
    }*/
  }

  addRandomItem(item) {
    const randomItem = this.game.make.image(0, 0, 'shelves', item);
    const itemWidth = randomItem.width + 20;
    const shelfWidth = this.costume.width - itemWidth;

    randomItem.anchor.set(0.5, 1);
    randomItem.x = itemWidth / 2 + (Math.random() * shelfWidth - shelfWidth * 0.5 - itemWidth / 2);
    randomItem.y = -this.costume.height + 50;
    this.costume.addChild(randomItem);
  }

  getWorldBounds() {
    let bounds = this.costume.getBounds();

    bounds.width = bounds.width * 0.9;
    bounds.x += bounds.width * 0.05;

    bounds.height = bounds.height * 0.5;
    bounds.y += bounds.height * 0.25;

    bounds.y += this.game.camera.view.y;

    return bounds;
  }
}
